import { CollectionResponse, Fetchable } from 'src/interfaces/api/api';
import api from 'src/config/api';
import { getJsonResponse } from 'src/utils/ApiUtils';
import Agency from 'src/interfaces/api/Agency';
import useAuth from './useAuth';
import React, { useContext, useEffect, useMemo, useState } from 'react';

interface ContextValue {
  agencies: Fetchable<Agency[]>;
}

const Context = React.createContext<ContextValue | undefined>(undefined);

export const AgenciesContextProvider: React.FC = (props) => {
  const { children } = props;
  const [agencies, setAgencies] = useState<Fetchable<Agency[]>>({ status: 'fetching' });
  const { fetch } = useAuth();

  useEffect(() => {
    const { endpoint, ...options } = api.agency.getAllAgency();

    fetch(endpoint, options)
      .then((response) => getJsonResponse<CollectionResponse<Agency>>(response))
      .then((collection) => {
        setAgencies({
          status: 'fetched',
          data: collection.items,
        });
      })
      .catch((error) => {
        setAgencies({
          status: 'error',
          error,
        });
      });
  }, []);

  const contextValue = useMemo<ContextValue>(
    () => ({
      agencies,
    }),
    [agencies]
  );

  return <Context.Provider value={contextValue}>{children}</Context.Provider>;
};

export default function useAgencies(): ContextValue {
  const context = useContext(Context);

  if (context === undefined) {
    throw new Error('You must wrap components that call `useAgencies` by a `AgenciesContextProvider`');
  }

  return context;
}
